import { createApi } from '@reduxjs/toolkit/query/react';
import { SearchResponse } from 'fym-common/src/types/searchService';
import { InspectByUrlResponse } from 'fym-common/src/types/inspectService';
import { config } from '../../config/config';
import { customBaseQuery } from './utils/customBaseQuery';
import { SearchOptions } from './musicAPI.types';
import { APIType } from './types';

export const baseUrl = config.musicApiURL(false);
console.log('Using redux musicAPI base url:', baseUrl);

export const musicAPI = createApi({
  reducerPath: 'musicAPI',
  baseQuery: customBaseQuery(baseUrl, APIType.music),
  endpoints: (builder) => ({
    inspectByUrl: builder.query<InspectByUrlResponse, string>({
      query: (url) => ({
        url: `inspect/url`,
        method: 'POST',
        body: JSON.stringify({ url }),
      }),
    }),
    search: builder.query<SearchResponse, SearchOptions>({
      query: ({ track, album, artist, sources, type }) => ({
        url: `search`,
        method: 'POST',
        body: JSON.stringify({ type, track, album, artist, sources }),
      }),
    }),
  }),
});

export const { useLazySearchQuery, useLazyInspectByUrlQuery } = musicAPI;
